var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('rest-form-item',{attrs:{"label":_vm.$t('ChannelConfig_Mitto_ApiKey'),"prop":"access_key"}},[_c('el-input',{attrs:{"placeholder":_vm.$t('ChannelConfig_Mitto_ApiKey_Placeholder')},model:{value:(_vm.model.params.api_key),callback:function ($$v) {_vm.$set(_vm.model.params, "api_key", $$v)},expression:"model.params.api_key"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42f5bc82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/channels/providers/Mitto.vue
// module id = null
// module chunks = 